import { Trans } from "@lingui/react/macro";

import type { components } from "@/shared/api";

type AnalysisStatus = components["schemas"]["AnalysisStatus"];

// Подпись ссылки на разбор по его статусу.
export const AnalysisLinkLabel = ({ status }: { status: AnalysisStatus | null }) => {
  switch (status) {
    case "done":
      return <Trans>Open analysis</Trans>;
    case "failed":
      return <Trans>Analysis failed</Trans>;
    default:
      return <Trans>Analyzing…</Trans>;
  }
};
